export default __webpack_public_path__ + "static/media/bg10.be601950.svg";